import { queryRiskLevel, queryRiskLevelByCampaigns } from '@/api/creatAd';
import './riskLevelConfirm.css';

function text(value) {
  return value == null ? '' : String(value);
}

function accountTitle(account) {
  return (account && (account.displayName || account.name)) || '';
}

export function parseSaleId(saleId) {
  if (saleId == null || saleId === '') return null;
  const raw = String(saleId).trim();
  if (!/^[1-9]\d*$/.test(raw)) return null;
  const num = Number(raw);
  if (num > 2147483647) return null;
  return num;
}

function findAccount(accounts, accountId) {
  return (accounts || []).find((item) => item && String(item.id) === String(accountId));
}

function collectAccounts(vm) {
  return [vm.currentAccount, ...(vm.accountsList || []), ...(vm.notCurrentNumAccounts || []), ...(vm.$store.getters.accountsList || [])];
}

export function riskAccountName(vm, returnedAccountId, requestedAccountId) {
  const accounts = collectAccounts(vm);
  const current = vm.$store.getters.currentAccountInfo;
  if (text(returnedAccountId) === text(requestedAccountId)) {
    if (current && String(current.id) === text(requestedAccountId)) return accountTitle(current);
    return accountTitle(findAccount(accounts, requestedAccountId));
  }
  return accountTitle(findAccount(accounts, returnedAccountId));
}

function escapeHtml(value) {
  return text(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function riskFacts(options) {
  const productDesc = [escapeHtml(options.productId), escapeHtml(options.productName)].filter(Boolean).join(' ');
  const accountDesc = [escapeHtml(options.accountId), escapeHtml(options.accountName)].filter(Boolean).join(' ');
  const productLevel = escapeHtml(options.productRiskLevel);
  const accountLevel = escapeHtml(options.accountRiskLevel);
  const campaignName = escapeHtml(options.campaignName);
  const head = options.campaignId
    ? `${campaignName ? `<span class="risk-level-name">${campaignName}</span>` : ''}<span class="risk-level-id">系列 ${escapeHtml(options.campaignId)}</span>`
    : '';
  return (
    `<span class="risk-level-item">${head}` +
    `<span class="risk-level-line"><span class="risk-level-k">产品等级 <b>${productLevel}</b></span>${productDesc}</span>` +
    `<span class="risk-level-line"><span class="risk-level-k">账户等级 <b>${accountLevel}</b></span>${accountDesc}</span>` +
    `</span>`
  );
}

export function riskSentence(productLevel, accountLevel) {
  const pair = productLevel && accountLevel
    ? `产品风控等级（<b>${escapeHtml(productLevel)}</b>）与账户等级（<b>${escapeHtml(accountLevel)}</b>）不匹配`
    : '产品风控等级与账户等级不匹配';
  return `<span class="risk-level-warn">${pair}，继续投放可能会带来风险哦，请确认是否继续。</span>`;
}

export function singleRiskMessage(data, accountName) {
  return riskFacts({
    productId: data.productId,
    productName: data.productName,
    productRiskLevel: data.productRiskLevel,
    accountId: data.accountId,
    accountName,
    accountRiskLevel: data.accountRiskLevel,
  }) + riskSentence(text(data.productRiskLevel), text(data.accountRiskLevel));
}

export const confirmOptions = {
  type: 'warning',
  confirmButtonText: '继续',
  cancelButtonText: '取消',
  closeOnClickModal: false,
  closeOnPressEscape: false,
  dangerouslyUseHTMLString: true,
  customClass: 'risk-level-confirm',
};

function saleEditor(vm) {
  return vm.$refs && vm.$refs.saleInfo;
}

export function adoptVisibleSale(vm) {
  const form = vm.adSeriesFormObj;
  const editor = saleEditor(vm);
  if (!form || !editor) return;
  if (!form.sale && editor.saleMsg) vm.$set(form, 'sale', editor.saleMsg);
  const site = editor.saleInfo && editor.saleInfo.coll;
  if (!form.site && site) vm.$set(form, 'site', site);
}

function clearAssignSale(vm) {
  vm.$set(vm.adSeriesFormObj, 'sale', null);
  vm.$set(vm.adSeriesFormObj, 'site', null);
  vm.$set(vm.adSeriesFormObj, 'targetUrl', null);
  const editor = saleEditor(vm);
  if (!editor) return;
  if (editor.saleInfo) {
    editor.saleInfo.coll = null;
    editor.saleInfo.sale_id = null;
  }
  editor.saleMsg = null;
}

export function checkAssignSaleRisk(vm) {
  if (!vm || vm.saleRelationType !== 'assign_sale') return;
  adoptVisibleSale(vm);
  const form = vm.adSeriesFormObj || {};
  const saleId = parseSaleId(form.sale && form.sale.saleId);
  const accountId = text(form.toAccountId).trim();
  if (!accountId || saleId == null) return;
  const key = accountId + '\0' + saleId;
  if (vm.riskCheckedKey === key) return;
  vm.riskCheckedKey = key;
  const seq = ++vm.riskCheckSeq;
  queryRiskLevel({ accountId, saleId })
    .then((res) => {
      if (seq !== vm.riskCheckSeq) return;
      if (!res || res.code != 0) {
        if (vm.riskCheckedKey === key) vm.riskCheckedKey = '';
        vm.$message.warning('风控等级暂时无法确认，可继续填写');
        return;
      }
      if (!res.data || res.data.hasRisk !== true) return;
      if (vm.saleRelationType !== 'assign_sale') return;
      const currentSaleId = parseSaleId(vm.adSeriesFormObj.sale && vm.adSeriesFormObj.sale.saleId);
      const currentAccountId = text(vm.adSeriesFormObj.toAccountId).trim();
      if (currentSaleId !== saleId || currentAccountId !== accountId) return;
      vm.$nextTick(() => {
        vm.$confirm(singleRiskMessage(res.data, riskAccountName(vm, res.data.accountId, accountId)), '风险提示', confirmOptions)
          .then(() => {})
          .catch(() => {
            if (seq !== vm.riskCheckSeq) return;
            if (vm.riskCheckedKey === key) vm.riskCheckedKey = '';
            clearAssignSale(vm);
          });
      });
    })
    .catch(() => {
      if (seq !== vm.riskCheckSeq) return;
      if (vm.riskCheckedKey === key) vm.riskCheckedKey = '';
      vm.$message.warning('风控等级暂时无法确认，可继续填写');
    });
}

function campaignIdOf(row, level) {
  const raw = level === 'campaign' ? row && row.id : row && row.campaign_id;
  return text(raw).trim();
}

function uniqueCampaignIds(rows, level) {
  const ids = [];
  const seen = new Set();
  (rows || []).forEach((row) => {
    const id = campaignIdOf(row, level);
    if (!id || seen.has(id)) return;
    seen.add(id);
    ids.push(id);
  });
  return ids;
}

function rowAccountId(row) {
  return text(row && (row.rowAccountId || row.account_id)).trim();
}

function campaignBlock(vm, item, requestedAccountId, campaignName) {
  return {
    html: riskFacts({
      campaignId: item.campaignId,
      campaignName,
      productId: item.productId,
      productName: item.productName,
      productRiskLevel: item.productRiskLevel,
      accountId: item.accountId,
      accountName: riskAccountName(vm, item.accountId, requestedAccountId),
      accountRiskLevel: item.accountRiskLevel,
    }),
    productLevel: text(item.productRiskLevel),
    accountLevel: text(item.accountRiskLevel),
  };
}

/**
 * 打开复制抽屉之前核对系列上已有的商品。返回 true 才打开。
 */
export async function confirmCampaignCopyRisk(vm, rows, multiAccount) {
  const level = vm.level;
  const groups = new Map();
  if (multiAccount) {
    (rows || []).forEach((row) => {
      const accountId = rowAccountId(row);
      if (!accountId) return;
      if (!groups.has(accountId)) groups.set(accountId, []);
      groups.get(accountId).push(row);
    });
  } else {
    const accountId = text(vm.accountId || vm.$store.getters.accountId).trim();
    if (accountId) groups.set(accountId, rows || []);
  }

  const risks = [];
  let requested = 0;
  let requestFailed = 0;
  let hasUnconfirmed = false;
  for (const [accountId, groupRows] of groups) {
    const campaignIds = uniqueCampaignIds(groupRows, level);
    if (!campaignIds.length) continue;
    requested += 1;
    const names = new Map();
    if (level === 'campaign') {
      groupRows.forEach((row) => {
        const id = campaignIdOf(row, level);
        if (id && row.name) names.set(id, row.name);
      });
    }
    try {
      const res = await queryRiskLevelByCampaigns({ accountId, campaignIds });
      if (!res || res.code != 0 || !res.data) {
        requestFailed += 1;
        continue;
      }
      (res.data.risks || []).forEach((item) => {
        if (item.hasRisk !== true) return;
        const rowName = names.get(String(item.campaignId));
        risks.push(campaignBlock(vm, item, accountId, rowName || item.campaignName));
      });
      if ((res.data.unconfirmed || []).length) hasUnconfirmed = true;
    } catch (e) {
      requestFailed += 1;
    }
  }

  if (!requested) return true;
  if (!risks.length) {
    if (requestFailed === requested) {
      vm.$message.warning('风控等级暂时无法确认，可继续');
    } else if (requestFailed > 0 || hasUnconfirmed) {
      vm.$message.warning('部分系列风控等级暂时无法确认，可继续');
    }
    return true;
  }

  const pairs = new Set(risks.map((item) => item.productLevel + '\0' + item.accountLevel));
  const sentence = pairs.size === 1
    ? riskSentence(risks[0].productLevel, risks[0].accountLevel)
    : riskSentence('', '');
  const extra = requestFailed > 0 || hasUnconfirmed ? '<span class="risk-level-extra">部分系列风控等级暂时无法确认，可继续</span>' : '';
  try {
    await vm.$confirm(risks.map((item) => item.html).join('') + sentence + extra, '风险提示', confirmOptions);
    return true;
  } catch (e) {
    return false;
  }
}
